export const arrow_up = () => (
  <path
    d="M12 19V5m0 0l-7 7m7-7l7 7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
